import React from 'react';
import IconButton from "../../../../components/Button/IconButton";

const ButtonCargo = ({onClick, isSelected}) => {
    return (
        <IconButton
            text={'Груз'}
            icon={<svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_0_1702)">
                    <path
                        d="M17.0938 1.92899L6.20278 7.50499L1.87378 5.37499L12.5728 0.0919883C12.8128 -0.0300117 13.1008 -0.0300117 13.3528 0.0919883L17.0938 1.92899Z"
                        fill="#459EFF"/>
                    <path
                        d="M24.0615 5.37506L12.9795 10.8651L8.82949 8.82006L8.22949 8.51506L19.1325 2.94006L19.7325 3.24406L24.0615 5.37506Z"
                        fill="#459EFF"/>
                    <path
                        d="M12.0916 12.447L12.0796 24L1.46563 18.461C1.16563 18.303 0.973633 17.986 0.973633 17.645V6.95703L5.47163 9.17303V13.069C5.47163 13.568 5.87963 13.982 6.37163 13.982C6.86363 13.982 7.27163 13.568 7.27163 13.069V10.074L7.87163 10.366L12.0916 12.447Z"
                        fill="#135CA9"/>
                    <path
                        d="M24.9616 6.96912L13.8916 12.4351L13.8796 23.9881L24.9736 18.1951L24.9616 6.96912Z"
                        fill="#135CA9"/>
                </g>
                <defs>
                    <clipPath id="clip0_0_1702">
                        <rect width="24" height="24" fill="white" transform="translate(0.973633)"/>
                    </clipPath>
                </defs>
            </svg>}
            isSelected={isSelected}
            info={{
                label: '',
                name: 'Груз',
                text: 'Отправление от 0,5 кг до нескольких паллет общим весом 1,5 тонны'
            }}
            onClick={onClick}
        />
    );
};

export default ButtonCargo;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/buttons/buttonCargo.jsx